import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { Headerbar, Table, Loader, ListContainer, ConfirmButton, StatusBox } from '../../Reusable'

import { Fire, Time, Tools } from '../../../services'
import { CopyToClipboard } from 'react-copy-to-clipboard'

import FadeIn from 'react-fade-in';
import GoogleMapReact from 'google-map-react';

import { ASSO_TYPE, PLACE_TYPE, ADS_MAKER_TYPE } from '../../../types/types'

const { useHistory } = require('react-router-dom')

interface Props {
  match: any;
}
const ProsScreen: React.FC<Props> = (props) => {
  
  const user = useSelector(state => state.authReducer.user)
  const [loading, setLoading] = React.useState(false)
  const [search, setSearch] = React.useState('')
  const [copy, setCopy] = React.useState<any>(null)
  const [copying, setCopying] = React.useState(false)
  const [stats, setStats] = React.useState<any>({})
  const history = useHistory()
  const [error, setError] = React.useState('')

  React.useEffect(() => {
    fetchStats()
  }, [])

  const fetchStats = async () => {
    try {
      const genericRef = Fire.store().collection('stats').doc('generic')
      const generic = await Fire.doc(genericRef)
      if (generic) {
        setStats(generic || {})
      }
    } catch (err) {
      console.warn(err)
    }
  }

  const copyUsers = async () => {
    const usersRef = Fire.store().collection('users')

    setCopying(true)
    try {
      const users = await Fire.list(usersRef)

      let msg = ''
      let count = 0
      for (const user of users) {
        if (user.email) {
          msg += user.email + "\n"
          count += 1
        }
      }
      setCopy({ users: msg, length: count })
    } catch (err) {
      console.warn(err)
    }
    setCopying(false)
  }

  const onFetch = async () => {
    try {
      const ref = Fire.store().collection('pros')
        .orderBy('createdAt', 'desc')
      const list = await Fire.list(ref)
      for (const item of list) {
        item.stripe_active_col = item.stripe_verified ? 'Oui' : 'Non'
        item.type_col =
          item.type === ASSO_TYPE ? 'Association' :
          item.type === PLACE_TYPE ? 'Etablissement':
          item.type === ADS_MAKER_TYPE ? 'Annonceur':
          'Inconnu'
        item.date_created_col = item.createdAt ? Fire.getDateFor(item.createdAt) : new Date()
        item.date_col = item.createdAt ? Time.renderDayWithNumbers(item.createdAt) : '-'
      }
      return list
    } catch (err) {
      setError("Impossible de charger les profesionnels")
      console.warn(err)
    }
    return []
  }

  const sorting = (search: string, items: any[]) => {
    return items.filter((item) => Tools.matchesSearch(search, item.name) || Tools.matchesSearch(search, item.email))
  }

  const columns = [
    { name: 'Nom', string: 'name', sortable: true, accessor: 'name' },
    { name: 'Type', string: 'type', sortable: true, accessor: 'type_col' },
    { name: 'Virements activés', string: 'stripe_active_col', sortable: true, accessor: 'stripe_active_col' },
    { name: 'Créé le', date: 'date_created_col', sortable: true, accessor: 'date_col' },
  ]

  return (
    <div className="wrapper">
      <Headerbar
        title="Comptes professionnels"
        />

      <div className="content-wrapper">
        <div className="content users">
          <div className="container-fluid">
            
            <FadeIn>

            <div className="row">
              <div className="info-box col-sm">
                <span className="info-box-icon bg-success"><i className="far fa-flag"></i></span>

                <div className="info-box-content">
                  <span className="info-box-text">Professionels</span>
                  <span className="info-box-number">{stats.pros_count || 0}</span>
                </div>
              </div>

            </div>

            <ListContainer
              title="Professionels"
              searchTitle="Rechercher un pro"
              createTitle="Créer un professionel"
              onCreate={() => history.push('/admin/pro/new')}
              onSelect={(item) => history.push('/admin/pro/' + item.id + '/recap')}
              //error={error}
              onFetch={onFetch}
              sorting={sorting}
              renderColumns={() => (columns)}
              />

            </FadeIn>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProsScreen
